import { useEffect } from 'react';
import { getRangeForSegments } from '../../helpers/getRangeForSegments';
import { useSetSegmentsRange } from '../../stores/stream-screen.store';
import { useStreamSegmentsList } from './useStreamSegmentsQuery';

/**
 * Hook to sync segments range from React Query to the store.
 * This ensures the store has the current segments range for validation purposes.
 */
export function useSyncSegmentsRange() {
  const segments = useStreamSegmentsList();
  const setSegmentsRange = useSetSegmentsRange();

  useEffect(() => {
    const range = getRangeForSegments(segments);
    setSegmentsRange(range?.from ?? null, range?.to ?? null);
  }, [segments, setSegmentsRange]);
}
